// CheckboxOption.js
import React from 'react';

const CheckboxOption = ({ value, onChangeFunc }) => {
  const handleCheckboxChange = (event) => {
    onChangeFunc(event.target.checked, value);
  };

  return (
    <div>
      <input class= "checkbox" type="checkbox" value={value} onChange={handleCheckboxChange} />
      <label>{value}</label>
    </div>
  );
};

export default CheckboxOption;
